import { render, staticRenderFns } from "./GroupTreeDeleteButton.vue?vue&type=template&id=4ff79682"
import script from "./GroupTreeDeleteButton.vue?vue&type=script&lang=js"
export * from "./GroupTreeDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports